(function () {

    'use strict';

    angular.module('asys')
        .component('asysBlockAngebotspartner', {
            require: {
                form: '^form'
            },
            bindings: {
                name: '@abaName',
                angebotspartner: '<abaAngebotspartner',
                angebotspartnerCompare: '<?abaAngebotspartnerCompare',
                options: '<?abaOptions',
                disabled: '<?abaDisabled'
            },
            templateUrl: 'bloecke/partner/blockAngebotspartner.html',
            controller: AngebotspartnerController,
            controllerAs: 'blockAngebotspartnerVm'
        });

    AngebotspartnerController.$inject = [
        '$filter',
        'lodash',
        'moment',
        'AppConfig',
        'AngebotModel',
        'MiscUtilsService',
        'SchluesselWerteUtilsService'
    ];
    function AngebotspartnerController($filter, _, moment, AppConfig, AngebotModel, MiscUtilsService, SchluesselWerteUtilsService) {
        var vm = this,
            formFieldNames = [
                'anrede',
                'vorname',
                'nachname',
                'geburtsdatum',
                'strasse',
                'postleitzahl',
                'ort'
            ];

        vm.$onInit = onInit;

        vm.isArbeitergeberBerufErlaubt = isArbeitergeberBerufErlaubt;
        vm.isAnredeErlaubt = isAnredeErlaubt;
        vm.isVorNachnameErlaubt = isVorNachnameErlaubt;
        vm.isVorameErlaubt = isVorameErlaubt;
        vm.isNachnameErlaubt = isNachnameErlaubt;
        vm.isGeburtsdatumErlaubt = isGeburtsdatumErlaubt;
        vm.isAdresseErlaubt = isAdresseErlaubt;
        vm.isPostleitzahlDisabled = isPostleitzahlDisabled;
        vm.isAdresseDisabled = isAdresseDisabled;
        vm.isLinkAngebotspartnerAenderErlaubt = isLinkAngebotspartnerAenderErlaubt;
        vm.onAngebotspartnerAendern = onAngebotspartnerAendern;

        function activate() {
            vm.angebotModel = AngebotModel.get();

            vm.options = vm.options || {};

            vm.minGeburtsdatum = vm.options.minGeburtsdatum || moment().subtract(120, 'years').format(AppConfig.API.dateFormat);
            vm.maxGeburtsdatum = vm.options.maxGeburtsdatum || moment().format(AppConfig.API.dateFormat);
            vm.linkAngebotspartnerAendernLabel = vm.options.linkAngebotspartnerAendernLabel || 'Partner ändern';

            vm.formFieldNames = _.zipObject(formFieldNames, _.map(formFieldNames, function (fieldName) {
                return [
                    vm.name,
                    fieldName
                ].join('_');
            }));
            vm.placeholders = {
                geburtsdatum: {
                    'min, max': [
                        $filter('date')(vm.minGeburtsdatum, 'dd.MM.yyyy'),
                        $filter('date')(vm.maxGeburtsdatum, 'dd.MM.yyyy')
                    ]
                }
            };

            vm.filteredAnreden = MiscUtilsService.filterArray(SchluesselWerteUtilsService.getSchluesselwert('anreden'), ['Herr', 'Frau', 'Divers'], 'bezeichnung', true);

            if (!isArbeitergeberBerufErlaubt() && !vm.disabled) {
                _.set(vm.fahrzeughalter, 'arbeitgeber', null);
                _.set(vm.fahrzeughalter, 'beruf', null);
            }
            vm.isInReadOnlyMode = !!_.get(vm.angebotspartner, 'partnernummer');
        }
        function onInit() {
            activate();
        }
        function isPostleitzahlDisabled() {
            return MiscUtilsService.isNotEmpty(_.get(vm.angebotspartner, 'postleitzahl'));
        }

        function isAdresseDisabled() {
            return (
                vm.disabled ||
                (
                    vm.isInReadOnlyMode &&
                    (
                        MiscUtilsService.isEverythingNotEmpty(_.get(vm.angebotspartner, 'strasse'), _.get(vm.angebotspartner, 'postleitzahl'), _.get(vm.angebotspartner, 'ort'))
                    )
                )
            );
        }

        function isLinkAngebotspartnerAenderErlaubt() {
            return (
                !!_.get(vm.angebotspartner, 'partnernummer') &&
                !vm.disabled
            );
        }

        function onAngebotspartnerAendern() {
            vm.origFahrzeughalter = _.cloneDeep(vm.angebotspartner);

            _.keys(vm.angebotspartner).forEach(function (key) {
                vm.angebotspartner[key] = null;
            });

            activate();
        }
        function isArbeitergeberBerufErlaubt() {
            var mitgliedsart = _.get(vm.angebotspartner, 'mitgliedsart.wert');

            return (
                vm.options.showArbeitgeberBeruf !== false &&
                (
                    MiscUtilsService.isEmpty(mitgliedsart) ||
                    _.includes(AppConfig.ANGEBOT.mgaPrivat, mitgliedsart)
                )
            );
        }

        function isAnredeErlaubt() {
            if (!_.get(vm.angebotspartner, 'anrede.wert') && vm.isInReadOnlyMode) {
                return false;
            }

            return vm.options.showAnrede !== false;
        }

        function isVorNachnameErlaubt() {
            return isVorameErlaubt() || isNachnameErlaubt();
        }

        function isVorameErlaubt() {
            if (!_.get(vm.angebotspartner, 'vorname') && vm.isInReadOnlyMode) {
                return false;
            }

            return vm.options.showVorname !== false;
        }

        function isNachnameErlaubt() {
            if (!_.get(vm.angebotspartner, 'nachname') && vm.isInReadOnlyMode) {
                return false;
            }

            return vm.options.showVorname !== false;
        }

        function isGeburtsdatumErlaubt() {
            if (!_.get(vm.angebotspartner, 'geburtsdatum') && vm.isInReadOnlyMode) {
                return false;
            }

            return vm.options.showGeburtsdatum !== false;
        }

        function isAdresseErlaubt() {
            if (!_.get(vm.angebotspartner, 'strasse') && vm.isInReadOnlyMode) {
                return false;
            }

            return vm.options.showAdresse !== false;
        }
    }
})();
